<script setup lang="ts">
import type { components } from '~/types/napis'

defineProps({
  tags: {
    type: Array as PropType<components['schemas']['DiscussionTagOptionSchema'][]>,
    required: true
  },
  postId: { type: String, required: true }
})
</script>

<template>
  <div class="tag-pill-list">
    <PageForumTagPill v-for="tag in tags" :key="`post-${postId}-${tag.slug_name}`" :tag="tag" />
  </div>
</template>

<style scoped lang="scss">
.tag-pill-list {
  display: flex;
  gap: 5px;
}
</style>
